// @ts-nocheck
import {Column} from 'react-table'

import { useIntl } from 'react-intl'; 
import { Option } from '../../core/_models';
import { OptionCustomHeader } from './OptionCustomHeader';
import { OptionActionsCell } from './OptionActionsCell';

const optionsColumns: ReadonlyArray<Column<Option>> = [

 
  {
    Header: (props) => (
      <OptionCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'translations[0].title',
    Cell: ({ row }) => (
      <span>{row.original.translations?.[0]?.title}</span> 
    ),  },


  {
    Header: (props) => (
      <OptionCustomHeader tableProps={props} title='' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <OptionActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {optionsColumns}
